<template>
  <div :class="['check-input']">
    <div :style="{}" :class="['input-container']">
      <!-- 前置内容 -->
      <span class="input__prefix">
        <slot name="prefix"> </slot>
      </span>

      <input
      ref="input"
        v-model="nativeVal"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        v-bind="[$props, $attrs]"
        class="by-input__inner"
      />

      <!-- 后置内容 -->
      <div v-if="$slots.suffix" class="input__suffix">
        <!-- <slot name="suffix"> </slot> -->
        <div class="input__suffix__text" style="background-color: #89a4d7">
          <!-- <span>KG</span> -->
          <slot name="suffix"> </slot>
        </div>
      </div>
      <!-- 自定义后置 -->
      <div class="input__custom__suffix" v-if="$slots.custom_suffix">
        <slot name="custom_suffix"> </slot>
      </div>
    </div>
  </div>
</template>
  
  <script>
import Emitter from "@/utils/emitter";
export default {
  mixins: [Emitter],
  inheritAttrs: false,
  props: {
    number: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: "",
    },
    type:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      nativeVal: this.value,
    };
  },
  watch: {
    nativeVal() {
      if (this.value !== this.nativeVal) {
        this.nativeVal = this.value;
      }
    },
  },
  methods: {
    focus() {
      // setTimeout(() => {
        this.$refs["input"].focus();
      // }, 0);
    },
    handleFocus(e) {},
    handleBlur() {
      this.dispatch("ByFormItem", "by.form.blur", [this.value]);
    },
    handleInput(e) {
      // debugger;
      if (this.number && isNaN(Number(e.target.value)) && this.type != 'float') {
        return false;
      }
      if(this.type == 'float'){
        let ctrValue = e.target.value
        if (ctrValue) {
          //ctrValue = ctrValue.replace(/^\./g, "");//验证第一个字符是数字而不是.
          ctrValue = ctrValue.replace(/[^\d\.]/g, "");
          if (ctrValue.indexOf(".") > -1) {
            let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
            if (s.length > 3) {
              ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 4);
            }
          }
          //获取小数点前面的值
          let arr = ctrValue.split(".");
          let le = arr[0].length;
          if (le > 7) {
            let int = arr[0].substring(0, 7);
            if (ctrValue.indexOf(".") > -1) {
              ctrValue = int + "." + arr[1];
            } else {
              ctrValue = int;
            }
          }
        }
        this.$emit("input", ctrValue);
      }else{
        this.$emit("input", e.target.value);
      }
      
      
    },
  },
};
</script>
  
  <style lang="scss" scoped >
.check-input {
  height: 60px;
  .input-container {
    font-size: 15px;
    padding-left: 20px;
    position: relative;
    height: 100%;
    background-color: #577ec7;
    border-radius: 30px;
    display: flex;

    .input__prefix {
      color: #fff;
      // height:100%;
      text-align: center;
      line-height: 60px;
      & > * {
        margin-right: 10px;
      }
    }
    .input__suffix {
      padding: 10px;
      padding-left: 0;
    }
    .input__suffix__text {
      background-color: rgb(137, 164, 215);
      padding: 10px 30px;
      border-radius: 20px;
      color: #fff;
    }
    .input__custom__suffix {
      padding: 10px;
      line-height: 40px;
    }
  }
  .by-input__inner {
    height: 100%;
    background-color: #577ec7;
    border: none;
    box-sizing: border-box;
    color: #fff;
    display: inline-block;
    font-size: inherit;
    line-height: 100%;
    outline: none;
    flex: 1;
    width: 0; //不然flex不生效,可能input有默认宽度
    border-radius: 30px;
    &:focus {
      // border-color: red !important;
      outline: none !important;
    }
    @include inputPlaceholder(#abbee3);
  }
}

.is_error .input-container{
  border: 1px solid red;
}
</style>


// WEBPACK FOOTER //
// src/components/reception/checkPrice/components/CheckInput.vue